import { humanize } from '@ideon-api/ideon-ui'
import universe from './entitlement-universe.json'

export type Market = 'Small Group' | 'Level-Funded'
export const MARKETS: readonly Market[] = ['Small Group', 'Level-Funded']

export const marketFor = (productLine: string): Market => (productLine === 'level_funded' ? 'Level-Funded' : 'Small Group')

export const productLineLabel = (productLine: string): string => humanize(productLine)

// level_funded is a medical plan sold in another market, so the market keeps it apart from medical.
export const lineLabel = (productLine: string): string =>
  `${productLine === 'level_funded' ? 'Medical' : productLineLabel(productLine)} · ${marketFor(productLine)}`

const ANCILLARY_LINES: readonly string[] = universe.ancillary_product_lines

// Unlisted lines get a prefixed key, so a raw "ancillary" line cannot merge into the fixed group.
export function groupKeyFor(productLine: string): string {
  if (productLine === 'medical' || productLine === 'level_funded') return productLine
  return ANCILLARY_LINES.includes(productLine) ? 'ancillary' : `line:${productLine}`
}
